import { useEffect, useRef } from "react";
import MemoEditPop from "bodycodi/cmap/app/components/common/MemoEditPop";
import icon_right_gray from "bodycodi/cmap/app/svg/icon_right_gray.svg";

interface Memo {
  title: string;
  placeHolder: string;
  memoContent: string;
  memoReadOnly: string;
  onChangeMemo: (memo: string) => void;
  onClickUpdateMemo: () => void;
  onClickMemoPop: () => void;
}

const Memo = ({
  title,
  placeHolder,
  memoContent,
  memoReadOnly,
  onChangeMemo,
  onClickUpdateMemo,
  onClickMemoPop,
}: Memo) => {
  const memoRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!memoRef.current) return;
    if (memoRef.current.scrollHeight > 115) {
      memoRef.current.style.height = "115px";
      memoRef.current.scrollTop = memoRef.current.scrollHeight;
      return;
    }
    memoRef.current.style.height = "5px";
    memoRef.current.style.height = memoRef.current?.scrollHeight + "px";
  }, [memoReadOnly]);

  return (
    <>
      <div className="schedule-memo">
        <span>{title}</span>
        {title === "회원 메모" ? (
          <div className="user-memo" onClick={onClickMemoPop}>
            메모 상세보기
            <img src={icon_right_gray} alt="" />
          </div>
        ) : (
          <div className="memo-card" onClick={onClickMemoPop}>
            <textarea ref={memoRef} placeholder={placeHolder} value={memoReadOnly} readOnly />
          </div>
        )}
      </div>
      <MemoEditPop
        title={title}
        placeHolder={placeHolder}
        memoContent={memoContent}
        memoReadOnly={memoReadOnly}
        onEdit={onClickUpdateMemo}
        onChange={onChangeMemo}
      />
    </>
  );
};

export default Memo;
